/*
 * @Author: dumingying
 * @Date: 2020-12-22 09:32:00
 * @LastEditTime: 2020-12-22 17:19:14
 * @Description: 页面接口
 * @FilePath: /src/api/index.js
 */
import { ajax } from './ajax.js'
// 获取省市区县信息
const getAddress = params => {
  return ajax({
    url: 'Register/Ajax/GetAllAddressSn.aspx',
    params: params,
    type: 'GET'
  })
}
// 发送短信验证码
const getVerificationTel = params => {
  return ajax({
    url: 'Register/Ajax/VerificationTel.aspx',
    params: params,
    type: 'POST'
  })
}
// 联系人信息页注册提交
const getDealerRegister = params => {
  return ajax({
    url: 'Register/Ajax/DealerRegister.aspx',
    params: params,
    type: 'GET'
  })
}
// step 2 地址图片等信息更新
const DealerUpdate = params => {
  return ajax({
    url: 'Register/Ajax/DealerUpdate.aspx',
    params: params,
    type: 'POST'
  })
}
// step 2 获取品牌
const GetAllBrand = params => {
  return ajax({
    url: 'Register/Ajax/GetAllBrand.aspx',
    params: params,
    type: 'GET'
  })
}
// step 2 获取级别
const GetDealerLevel = params => {
  return ajax({
    url: 'Register/Ajax/GetDealerLevel.aspx',
    params: params,
    type: 'GET'
  })
}
// step 2 上传图片
const DealerUpload = params => {
  return ajax({
    url: 'Register/Ajax/DealerUpload.aspx',
    params: params,
    type: 'POST'
  })
}
export default {
  getAddress,
  getVerificationTel,
  getDealerRegister,
  DealerUpdate,
  GetAllBrand,
  GetDealerLevel,
  DealerUpload
}



// WEBPACK FOOTER //
// ./src/api/index.js